// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Link from 'components/Link/Link'
// import LiquidImage from 'components/Image/LiquidImage'
import { loop } from 'utilities/objects'

class Work extends React.Component {
	constructor() {
		super()

		this.state = {
			showContent: false
		}
	}

	componentDidMount() {
		this._isMounted = true

		this.update()
	}

	componentWillUnmount() {
		this._isMounted = false
	}

	componentDidUpdate( prevProps, prevState ) {
		this.update()
	}

	update = () => {
		const { history } = this.props
		const { showContent } = this.state

		if ( 'POP' == history.action && ! showContent ) {
			setTimeout( () => {
				this.setState( {
					showContent: true
				} )
			}, 400 )
		}
	}

	render() {
		const { postsData, match, location, history } = this.props
		const { showContent } = this.state

		if ( ! postsData ) {
			return null
		}

		if ( 'POP' == history.action && ! showContent ) {
			return null
		}

		let postsMarkup = []

		loop( postsData.items, ( key, item ) => {
			postsMarkup.push(
				<Link to={ item.url } className="-item" key={ key }>
					{ item.featured_image.url &&
						<div className="-image">
							<img className="-bg-right-cover" src={ item.featured_image.url } alt="" data-sampler="simplePlaneTexture" />
						</div>
					}

					<div className="-text-wrap">
						<span className="-cat subtitle">{ item.category.primary.name }</span>
						<h3 dangerouslySetInnerHTML={ { __html: item.title.rendered } }></h3>

						{ !! item.index_subtitle &&
							<p className="-item-subtitle" dangerouslySetInnerHTML={ { __html: item.index_subtitle } } />
						}
					</div>
				</Link>
			)
		} )

		const { pathname } = location
		const pathnameNoEndSlash = pathname.replace( /\/$/, '' )
		const { archivePageNumber } = match.params
		const postsPaginationMarkup = postsData.max_num_pages ? [ ...Array( postsData.max_num_pages ) ].map( ( e, i ) => {
			i++
			var className = archivePageNumber == i ? 'button -page is-active' : 'button -page'
			var newPath

			if ( pathnameNoEndSlash.match( /page\/\d+/g ) ) {
				newPath = pathnameNoEndSlash.replace( /page\/\d+/g, 'page/' + i )
			} else {
				newPath = pathnameNoEndSlash + '/page/' + i
			}

			return (
				<Link to={ newPath } className={ className } key={ i }>
					{ i }
				</Link>
			)
		} ) : ''

		const posts = postsMarkup.length ? (
			<div className="-posts">
				<div className="-inner">
					<div className="-items">
						{ postsMarkup }
					</div>
				</div>
			</div>
		) : ''

		const postsPagination = postsPaginationMarkup.length ? (
			<div className="-pagination">
				<h3>View Previous</h3>

				{ postsPaginationMarkup }
			</div>
		) : ''

		return (
			<div className="work">
				<div className="-inner">
					<div className="js-scroll-position"></div>

					{ posts }
					{ postsPagination }
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		postsData: state.page.selectedArchive
	}
}

export default connect( mapStateToProps )( Work )



// WEBPACK FOOTER //
// ./views/pages/archive/Work.jsx